'use strict';

import {observable, configure, action, makeObservable, flow} from "mobx";
configure({enforceActions: 'always'});

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';

import api from '../lib/Api';
import RegToolsInjector from "../common/RegToolsInjector";

const analyticsStore = appStore.getAnalyticsStore();

class OptionalChargesStore {
    state = States.initial;

    exceptionUtils = appStore.getExceptionUtils();

    formData = {};

    mockFormData = {
        QY: "",
        INS: "",
        INSANNL: "",
        INSDEPS: "",
        INSSPOUSE: "",

        INSDEPSU21: "",
        INSDEPS21: "",
        WPG: "",
        UWUSAS: "",
        ASUW: "",
        CMPS: "",

        WSL: "",

        INS_ACK: "",
        UPASS: "X",
        UPASSTOU: "X",
        UPASSRSN: "X",
        INSCONF: "" // blank INSCONF value --> no update in SA80082
    };

    showModal = false;

    onSuccess = () => {};

    mockData = {
        "studentSystemKey": "",
        "qtr": "3",
        "year": "2024",
        "num_quarters": "2",
        "num_ins_menus": "0",
        "student_no": "",
        "process_code": "0",
        "performed_action": "I",
        "eligible_sw": "Y",
        "email_address": "",
        "acad_year_gaip_sw": "",
        "enroll_requird_sw": "",
        "initial_tele_sw": "Y",
        "branch_code": "2",
        "class_code": "3",
        "resident_code": "0",
        "exemption_code": "0",
        "need_meningo": "",
        "need_voter": "",
        "need_riaa": "",
        "need_clery": "",
        "need_upass": "",
        "need_finliab": "",
        "error_msg": "",
        "available_qtr$1": "3",
        "available_year$1": "2024",
        "available_qtr$2": "4",
        "available_year$2": "2024",
        "available_qtr$3": "0",
        "available_year$3": "0",
        "available_qtr$4": "0",
        "available_year$4": "0",
        "tuit_due_dt_text": "JULY 5, 2024",
        "cover_end_dt_text": "AUGUST 31, 2024",
        "insurance_sel": "0",
        "ins_num_dep_u21": "0",
        "ins_num_dep_21": "0",
        "ins_update_sw": "Y",
        "ins_tier": "1",
        "ins_status_char": "X",
        "ins_cancel_reason": "0",
        "has_annual_ins_sw": "",
        "ins_annual_year": "0",
        "ins_annual_qtr": "0",
        "ta_ra_sw": "",
        "insurance_chg_sw": "",
        "curr_ins_sel_code": "0",
        "curr_ins_sel_amt": "0",
        "ins_menu_code$1": "0",
        "ins_menu_amt$1": "0",
        "ins_menu_code$2": "0",
        "ins_menu_amt$2": "0",
        "ins_menu_code$3": "0",
        "ins_menu_amt$3": "0",
        "ins_menu_code$4": "0",
        "ins_menu_amt$4": "0",
        "ins_menu_code$5": "0",
        "ins_menu_amt$5": "0",
        "ins_menu_code$6": "0",
        "ins_menu_amt$6": "0",
        "ins_menu_code$7": "0",
        "ins_menu_amt$7": "0",
        "ins_menu_code$8": "0",
        "ins_menu_amt$8": "0",
        "ins_menu_code$9": "0",
        "ins_menu_amt$9": "0",
        "ins_menu_code$10": "0",
        "ins_menu_amt$10": "0",
        "ins_menu_code$11": "0",
        "ins_menu_amt$11": "0",
        "ins_menu_code$12": "0",
        "ins_menu_amt$12": "0",
        "ins_menu_code$13": "0",
        "ins_menu_amt$13": "0",
        "ins_menu_code$14": "0",
        "ins_menu_amt$14": "0",
        "ins_menu_code$15": "0",
        "ins_menu_amt$15": "0",
        "ins_menu_code$16": "0",
        "ins_menu_amt$16": "0",
        "ins_menu_code$17": "0",
        "ins_menu_amt$17": "0",
        "ins_admin_fee": "0",
        "ins_broker_fee": "0",
        "washpirg_sw": "X",
        "wpg_update_sw": "Y",
        "washpirg_amt": "0",
        "washpirg_chg_sw": "",
        "wsl_sw": "X",
        "wsl_update_sw": "Y",
        "wsl_amt": "0",
        "wsl_chg_sw": "",
        "uwusas_sw": "X",
        "uwusas_update_sw": "Y",
        "uwusas_amt": "0",
        "uwusas_chg_sw": "",
        "asuw_sw": "Y",
        "asuw_update_sw": "Y",
        "asuw_chg_sw": "",
        "insconf_sw": "Y",
        "upass_sw": "B",
        "upass_update_sw": "",
        "upass_amt": "0",
        "upass_reason": "0",
        "upass_chg_sw": ""
    }

    data = {
        show: {
            opChargeUpass: false,
            opChargeWashPIRG: false,
            opChargeUSAS: false,
            opChargeWSA: false,
            opChargeASUW: false,
            opChargeInsurance: false
        }
    };

    constructor() {
        makeObservable(this, {
            state: observable,
            formData: observable,
            showModal: observable,
            updateFormData: action,
            mount: action,
            //openModal: action,
            //closeModal: action
        })
    }

    mount = flow(function* (onSuccess, termId) {
        if (appStore.isStudent()) {
            this.state = States.pending;
            this.onSuccess = onSuccess;
            try {
                if (RegToolsInjector.isPreProdEnvironment()) {
                    this.data = {...yield api.getOptionalCharges(termId), ...this.data, ...RegToolsInjector.injectOptChargesData()};
                } else {
                    this.data = {...yield api.getOptionalCharges(termId), ...this.data};
                }
                this.preProcessFormData(this.data);
            } catch (e) {
                this.exceptionUtils.handleException(e);
                this.state = States.error;
            }
        } else {
            this.state = States.done;
        }
    }.bind(this));

    preProcessFormData = (data) => {
        // U-Pass
        if ( data.upass_sw !== "B" && data.upass_sw !== "A" && data.eligible_sw !== "N" ) {
            this.data.show.opChargeUpass = true;
        }

        // Wash PIRG & USAS & WSA
        if (parseInt(data.branch_code) === 0) {
            this.data.show.opChargeWashPIRG = true;
            this.data.show.opChargeUSAS = true;
            this.data.show.opChargeWSA = true;
        }

        // ASUW
        if (data.asuw_update_sw === "Y" && ((parseInt(data.exemption_code) < 5) || (parseInt(data.exemption_code) > 9))) {
            this.data.show.opChargeASUW = true;
        }

        // Insurance
        const isInternationalStudent = (data.hasOwnProperty("resident_code") && parseInt(data.resident_code) > 0);
        this.data.show.opChargeInsurance = !(!isInternationalStudent && parseInt(data.class_code) !== 8);

        // Setup formdata
        this.formData.INS = data.curr_ins_sel_code;

        if (data.ins_status_char !== "X") {
            let insuranceSelection = parseInt(data.insurance_sel);
            this.formData.INS = insuranceSelection;
            if (insuranceSelection > 4) {
                this.formData.INSANNL = "Y";
                insuranceSelection -= 4;
            }
            if (insuranceSelection > 1) {
                this.formData.INSDEPS = "Y";
                if (insuranceSelection !== 4) {
                    this.formData.INSSPOUSE = "Y";
                }
                this.formData.INSDEPSU21 = parseInt(data.ins_num_dep_u21);
                this.formData.INSDEPS21 = parseInt(data.ins_num_dep_21);
            }
        }

        this.formData.WPG = data.washpirg_sw;
        this.formData.WSL = data.wsl_sw;
        this.formData.UWUSAS = data.uwusas_sw;

        if (data.initial_tele_sw === "Y") {
            this.formData.ASUW = "Y";
        } else {
            if (
                data.asuw_update_sw !== "Y"
                ||
                (
                    parseInt(data.exemption_code) >= 5
                    &&
                    parseInt(data.exemption_code) >= 9
                )
            ) {
                this.formData.ASUW = "X";
            } else {
                this.formData.ASUW = data.asuw_sw;
            }
        }

        this.formData.UPASS = data.upass_sw;
        this.formData.UPASSRSN = data.upass_reason;
        this.formData.INSCONF = data.insconf_sw;
        this.formData.CMPS = data.branch_code;

        this.state = States.done;
    }

    updateFormData = (prop, value) => {
        this.formData[prop] = value;
    }

    saveOptCharges = flow(function* () {
        this.state = States.pending;
        try {
            let response = yield api.updateOptionalCharges(this.formData);
            this.state = States.done;
        } catch (e) {
            this.exceptionUtils.handleException(e);
            this.state = States.error;
        }
    }.bind(this));
}

export default new OptionalChargesStore();